import classNames from "classnames";

import { FC } from "react";
import { Item } from "../../http/types/items";
import { getMinutesRoundedTimestamp } from "../../utils";
import SvgNoImage from "../icons/SvgNoImage";
import Icon from "../ui/Icon";
import WhiteSpacePreWrapText from "../ui/WhiteSpacePreWrapText";
import styles from "./ItemPage.module.css";

type ItemPageProps = {
  item?: Item;
  variant?: "page" | "dialog";
};

const ItemPage: FC<ItemPageProps> = ({ item: data, variant = "page" }) => {
  return (
    <>
      <div
        className={classNames(styles.container, {
          [styles.pageLayout]: variant === "page",
          [styles.dialogLayout]: variant === "dialog",
        })}
      >
        <div
          className={classNames(styles.imgContainer, {
            [styles.pageImageContainer]: variant === "page",
            [styles.dialogImageContainer]: variant === "dialog",
          })}
        >
          <div className={classNames(styles.img, { [styles.background]: !data?.image })}>
            {data?.image ? (
              <img src={`${import.meta.env.VITE_BUCKET_URL}${data.image}?${getMinutesRoundedTimestamp()}`} />
            ) : (
              <Icon glyph={SvgNoImage} />
            )}
          </div>
        </div>
        <div
          className={classNames(styles.textContent, {
            [styles.pageTextContent]: variant === "page",
            [styles.dialogTextContent]: variant === "dialog",
          })}
        >
          {!!data?.name && <div className={styles.name}>{data.name}</div>}
          <WhiteSpacePreWrapText>{data?.description}</WhiteSpacePreWrapText>
        </div>
      </div>
    </>
  );
};

export default ItemPage;
